import { render, staticRenderFns } from "./VoucherPrivate.vue?vue&type=template&id=36a9dc8f&scoped=true"
import script from "./VoucherPrivate.vue?vue&type=script&lang=js"
export * from "./VoucherPrivate.vue?vue&type=script&lang=js"
import style0 from "./VoucherPrivate.vue?vue&type=style&index=0&id=36a9dc8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a9dc8f",
  null
  
)

export default component.exports